<template>
  <basicContainer>
    <div class="yytbgl">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

        <el-tab-pane label="待支付" name="1"></el-tab-pane>
        <el-tab-pane label="已支付" name="2"></el-tab-pane>
        <el-tab-pane label="所有" name="0"></el-tab-pane>
      </el-tabs>
      <!-- 预约填报管理 -->
      <avue-crud
        :data="data"
        :option="option"
        :page.sync="page"
        @on-load="onLoad"
        :search.sync="search"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
      >
      <template v-slot:menu="{type,size,row}">
         <el-button size="small" type="text" icon="el-icon-printer" @click.stop="print(row)" v-if="row.procDefId == ''">打印</el-button>
       </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="payFun" :class="hide">支付</el-button>
      </template>
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>

export default {
  data() {
    return {
      activeName: '1',
      hide: 'hide',
      formid: '', // 流程表单ID
      data: [],
      option: {
        dialogDrag: true,
        dialogClickModal: false,
        stripe: true,
        border: true,
        page: true,
        selection: true,
        align: 'left',
        menuAlign: 'center',
        menuWidth: 200,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 150,
        viewBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '申请人',
            prop: 'sqr',
            search: true,
            searchLabelWidth: 100
          },
          {
            label: '申请日期',
            prop: 'sqrq',
            search: true,
            searchLabelWidth: 100
          },
          {
            label: '申请类型',
            prop: 'sqlx'
          },
          {
            label: '申请单号',
            prop: 'sqdh',
            search: true,
            searchLabelWidth: 100

          },
          {
            label: '收款人',
            prop: 'skr',
            search: true,
            searchLabelWidth: 100
          },
          {
            label: '支付金额',
            prop: 'sjbxje'
          },
          {
            label: '项目编号',
            prop: 'xmid'

          },
          {
            label: '客户名称',
            prop: 'khmc'
          },
          {
            label: '项目名称',
            prop: 'xmmc'
          },
          {
            label: '报销一级部门',
            prop: 'yjbm',
            search: true,
            searchLabelWidth: 100

          },
          {
            label: '报销二级部门',
            prop: 'ejbmmc'

          },
          {
            label: '报销三级部门',
            prop: 'sjbmmc'
          },
          {
            label: '所属部门',
            prop: 'ssbm',
            search: true,
            searchLabelWidth: 100

          },
          {
            label: '职位',
            prop: 'zw'
          },
          {
            label: '申请事由',
            prop: 'keywords'

          },
          {
            label: '支付方式',
            prop: 'zffs',
            search: true,
            searchLabelWidth: 100
          },
          {
            label: '开户银行',
            prop: 'khyh'
          },
          {
            label: '银行账号',
            prop: 'yhzh'
          }
        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      search: {},
      tab: 1,
      ids: []
    }
  },

  methods: {
    payFun: function() {
      if (this.ids.length == 0 || this.ids.split(',').length == 0) {
        this.$message.error('请至少选择一条需要支付的数据')
        return
      }
      this.$http
        .post('/PayMentManage/insertPaymentInfo', this.ids.split(','))
        .then(res => {
          this.$message.success(res.msg)
          this.load()
        })
        .catch(error => {
          this.$message.error(error.msg || error.message)
        })
    },
    selectionChange(list) {
      this.ids = list.map((item) => item.id).join(',')
    },
    load(done) {
      console.log(this.tab)
      this.$http
        .post('/PayMentManage/pay-query', { entity: { ...this.search }}, {
          params: {
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize,
            payStatus: this.tab

          }
        })
        .then(res => {
          this.data = res.data.records || []
          this.page.total = res.data.total || res.data.records.length || 0
        })
        .catch(error => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          typeof done === 'function' && done()
        })
    },
    handleClick(tab, event) {
      if (tab.name == '1') {
        this.hide = ''
      } else {
        this.hide = 'hide'
      }
      this.tab = tab.name
      this.load()
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.load()
    },
    searchChange(params, done) {
      if (params.htqd !== undefined) {
        params.htqd = params.htqd.toString()
      }

      if (params.updatetime !== undefined) {
        params.updatetime = params.updatetime.toString()
      }
      this.search = params
      this.page.currentPage = 1
      this.load(done)
    },
    searchReset() {
      this.search = {}
      this.page.currentPage = 1
      this.load()
    },
    refreshChange() {
      this.load()
    },

    edit(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'caef7b7d7b2844fb90fbd02dff8fc1a2',
          pageKey: 'DO'
        }
      })
    },

    view(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'caef7b7d7b2844fb90fbd02dff8fc1a2',
          pageKey: 'VIEW'
        }
      })
    },

    print(row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.id__,
          processInstanceId: row.procInstId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW',
          FromId: 'application'

        }
      })
    }

  }
}
</script>

<style>
.hide {
  display: none;
}
</style>
